import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ColDef, GridOptions } from 'ag-grid-community';
import { TableUserService } from 'src/app/core/http/user.service';
import { SuperAdminResult, UsersCarriersInterface, SuperAdminInterface } from 'src/app/core/models/users.interfaces';
import * as XLSX from 'xlsx';
import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { DateTextComponent } from '../../date-text/date-text.component';
import { UserDetailModalComponent } from '../../user-detail-modal/user-detail-modal.component';
import { ConfirmChangeStatusUserComponent } from '../../confirm-change-status-user/confirm-change-status-user.component';
import { DialogAuditUserComponent } from '../../dialog-audit-user/dialog-audit-user.component';

@Component({
  selector: 'app-table-user-super-admin-carrier',
  templateUrl: './table-user-super-admin-carrier.component.html',
  styleUrls: ['./table-user-super-admin-carrier.component.scss']
})
export class TableUserSuperAdminCarrierComponent implements OnInit {
	valueInput;
	public columnDefs: ColDef[];
	filterText: string = '';
	carrierID:number;
	gridOptions: GridOptions;
	public filteredData: any[] = [];
	users: UsersCarriersInterface[];
	superAdmin: SuperAdminInterface[];
	constructor(private translate: TranslateService,private userService: TableUserService,private dialog: MatDialog) { }

	ngOnInit(): void {
		this.carrierID = parseInt(localStorage.getItem('courier_id'));
		this.translate.use(localStorage.getItem('language').toLowerCase());
		this.updateDataSuperAdmin();
		this.loadData();
		this.translate.onLangChange.subscribe((event: LangChangeEvent)=> {
			this.translate.use(event.lang);
			this.translate.get([
				'table-superadmin.fullName',
				'table-superadmin.email',
				'table-superadmin.activeDays',
				'table-superadmin.registerDate',
				'table-superadmin.expiredDate',
				'table-user.actions'
			]).subscribe( (t:any)=>{
				this.columnDefs = [
					{
						headerName: t['table-superadmin.fullName'],
						field: 'first_name',
						sortable: true,
						autoHeight: true,
						cellClass:'superAdminClassLink',
						headerClass:'borderHeaderGeneralSuperAdmin',
						cellRenderer: this.centeredCellRenderer,
						onCellClicked: ($event) => this.openModalUserDetail($event)
					},
					{
						headerName: t['table-superadmin.email'],
						field: 'email',
						sortable: true,
						autoHeight: true,
						cellClass:'superAdminClass',
						headerClass:'borderHeaderGeneralSuperAdmin',
						cellRenderer: this.centeredCellRenderer
					},
					{
						headerName: t['table-superadmin.activeDays'],
						field: 'active_days',
						sortable: true,
						autoHeight: true,
						cellClass:'superAdminClass',
						headerClass:'borderHeaderGeneralSuperAdmin',
						cellRenderer: this.centeredCellRenderer
					},
					{
						headerName: t['table-superadmin.registerDate'],
						field: 'registration_date',
						sortable: true,
						autoHeight: true,
						cellClass:'superAdminClass',
						headerClass:'borderHeaderGeneralSuperAdmin',
						cellRenderer: DateTextComponent
					},
					{
						headerName: t['table-superadmin.expiredDate'],
						field: 'registration_date',
						sortable: true,
						autoHeight: true,
						cellClass:'superAdminClass',
						headerClass:'borderHeaderGeneralSuperAdmin',
						cellRenderer: DateTextComponent
					}
				]
			})
		})
	}
	onFilterTextChange(event) {
		this.filterText = event.target.value;
		this.gridOptions.api.setQuickFilter(this.filterText);
		let api = this.gridOptions.api;
		let temporal = [];
		api.forEachNodeAfterFilter((node) => {
			temporal.push(node.data);
		});
		this.filteredData = temporal;
	}

	updateDataSuperAdmin(){
		this.translate.use(localStorage.getItem('language').toLowerCase());
		this.gridOptions = {
			columnDefs: [
				{
					headerName:this.translate.instant('table-superadmin.fullName'),
					field: 'first_name',
					sortable: true,
					autoHeight: true,
					cellClass:'superAdminClassLink',
					headerClass:'borderHeaderGeneralSuperAdmin',
					cellRenderer: this.centeredCellRenderer,
					onCellClicked: ($event) => this.openModalUserDetail($event)
				},
				{
					headerName: this.translate.instant('table-superadmin.email'),
					field: 'email',
					sortable: true,
					autoHeight: true,
					cellClass:'superAdminClass',
					headerClass:'borderHeaderGeneralSuperAdmin',
					cellRenderer: this.centeredCellRenderer
				},
				{
					headerName: this.translate.instant('table-superadmin.activeDays'),
					field: 'active_days',
					sortable: true,
					autoHeight: true,
					cellClass:'superAdminClass',
					headerClass:'borderHeaderGeneralSuperAdmin',
					cellRenderer: this.centeredCellRenderer
				},
				{
					headerName: this.translate.instant('table-superadmin.registerDate'),
					field: 'registration_date',
					sortable: true,
					autoHeight: true,
					cellClass:'superAdminClass',
					headerClass:'borderHeaderGeneralSuperAdmin',
					cellRenderer: DateTextComponent
				},
				{
					headerName: this.translate.instant('table-superadmin.expiredDate'),
					field: 'registration_date',
					sortable: true,
					autoHeight: true,
					cellClass:'superAdminClass',
					headerClass:'borderHeaderGeneralSuperAdmin',
					cellRenderer: DateTextComponent
				}
			],
			animateRows: true,
			pagination: true,
			paginationPageSize: 10,
			paginationAutoPageSize: true,
			enableCellChangeFlash: true,
			rowClass:'rowSuperAdminClass',
			defaultColDef: {
				flex: 1,
			},
			overlayNoRowsTemplate: this.translate.instant('general.empty'),
		}
	}

	loadData(){
		this.superAdmin=[];
		let data ={
			language: localStorage.getItem('language').toLowerCase(),
			is_module_courier : true,
			id_courier: this.carrierID
		}
		this.userService.getSuperAdminAsincrono(data).then( (res:SuperAdminResult)=>{

			if(res.result_return){
				res.result_return.forEach((item:any)=>{
					let hourRegistrationDate = item.registration_date.substring(0,2);
					let minutesRegistrationDate = item.registration_date.substring(3,5);
					let secondsRegistrationDate = item.registration_date.substring(6,8);
					let monthRegistrationDate = parseInt(item.registration_date.substring(9,11));
					let dayRegistrationDate = item.registration_date.substring(12,14);
					let yearRegistrationDate = item.registration_date.substring(15,19);
					let registrationDateString = yearRegistrationDate +'-'+monthRegistrationDate+'-'+dayRegistrationDate+' '+hourRegistrationDate+':'+minutesRegistrationDate+':'+secondsRegistrationDate;
					this.superAdmin.push({
						acronym_language:item.acronym_language,
						active_days: item.active_days,
						alias_username: item.alias_username,
						audit_package: item.audit_package,
						code_master: item.code_master,
						courier_name: item.courier_name,
						email: item.email,
						enable_token: item.enable_token,
						first_name: item.first_name,
						id_language: item.id_language,
						id_status: item.id_status,
						id_user: item.id_user,
						language_name: item.language_name,
						name_status: item.name_status,
						registration_date: registrationDateString,
						audit_employee: item.result_audit_emploche,
						surname: item.surname,
						url_token: item.url_token
					})
				})
				this.superAdmin = [...this.superAdmin];
			}
		}).catch(err=>{
			console.log(err)
		})
	}

	onExport() {
		const fileName = 'Users.xlsx';
		const excelParams = {
			fileName: fileName,
			sheetName: 'Carriers-SuperAdmin',
			columnWidths: [30, 20, 20, 20],
		};
		if (this.filteredData.length > 0) {
			const Data = this.filteredData || [];
			const excelData = Data.map((row) => {
				const { id_status,id_language,id_user,audit_package,audit_employee,code_master,url_token,	...rowDataWithoutFields} = row;
				return rowDataWithoutFields;
			});
			const wb = XLSX.utils.book_new();
			const ws = XLSX.utils.json_to_sheet(excelData);
			XLSX.utils.book_append_sheet(wb, ws, excelParams.sheetName);
			XLSX.writeFile(wb, fileName);
		} else if (this.superAdmin.length > 0 && this.filteredData.length === 0) {
			const Data = this.superAdmin || [];
			const excelData = Data.map((row) => {
				const { id_status,id_language,id_user,audit_package,audit_employee,code_master,url_token,	...rowDataWithoutFields} = row;
				return rowDataWithoutFields;
			});
			const wb = XLSX.utils.book_new();
			const ws = XLSX.utils.json_to_sheet(excelData);
			XLSX.utils.book_append_sheet(wb, ws, excelParams.sheetName);
			XLSX.writeFile(wb, fileName);
		}
	}
	centeredCellRenderer(params) {
		const cellValue = params.value;
		const cellDiv = document.createElement('div');
		cellDiv.style.display = 'flex';
		cellDiv.style.alignItems = 'center';
		cellDiv.style.justifyContent = 'center';
		cellDiv.style.height = '100%';
		cellDiv.innerText = cellValue;
		return cellDiv;
	}


	openModalUserDetail(event) {
		const dialogRef = this.dialog.open(UserDetailModalComponent, {
			width: '1456px',
			height: '1030px',
			data: event.data,
		});

		dialogRef.afterClosed().subscribe((result) => {
			console.log(`Dialog result: ${result}`);
		});
	}
	openConfirmChangeStatus(event) {
		const dialogRef = this.dialog.open(ConfirmChangeStatusUserComponent, {
			width: '500px',
			height: '200px',
			data: event,
		});

		dialogRef.afterClosed().subscribe((result) => {
			console.log(`Dialog result: ${result}`);
			const newData = this.users.slice();
			newData[result].status = 'INACTIVE';
			this.users = newData;
		});
	}
	openModalUserAudit(event) {
		const dialogRef = this.dialog.open(DialogAuditUserComponent, {
			width: '959px',
			height: '796px',
			data: event.data,
		});

		dialogRef.afterClosed().subscribe((result) => {
			console.log(`Dialog result: ${result}`);
		});
	}
}
